import React, { useCallback } from 'react';
import classnames from 'classnames';
import { FormattedMessage, useIntl } from 'react-intl';
import { useSelector, useDispatch } from 'react-redux';

import Global from '../../../store/global-selectors';
import { getLabelQueBatchesRequest, toggleLabelQue } from '../../../store/label-que/label-que.actions';
import { toggleNotificationHub } from '../../../store/notification-hub/notification-hub.actions';
import baseStyle from '../app-header.module.less';
import style from './label-queue-button.module.less';
import { PrintQueueIcon } from '../icons/print-queue-icon';
import messages, { appHeaderMessages } from '../messages';

const SingleDigit = 1;
const DoubleDigit = 2;
const TripleDigit = 3;

const DigitBasedClassName = {
  [SingleDigit]: style['single-digit'],
  [DoubleDigit]: style['double-digit'],
  [TripleDigit]: style['triple-digit'],
};

const getDigitBasedClassname = (alertCountDigits) => {
  return alertCountDigits > 2 ? DigitBasedClassName[TripleDigit] : DigitBasedClassName[alertCountDigits];
};

export const LabelQueueButton = () => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const labelQueBatches = useSelector(Global.selectLabelQueBatches);
  const labelQueBatchCount = labelQueBatches.length;
  const isLabelQueOpen = useSelector(Global.selectLabelQueIsOpen);

  const handleLabelQueueClick = useCallback(() => {
    if (!isLabelQueOpen) {
      dispatch(toggleNotificationHub(false));
    }
    dispatch(toggleLabelQue(!isLabelQueOpen));
    if (!isLabelQueOpen) {
      dispatch(getLabelQueBatchesRequest());
    }
  }, [dispatch, isLabelQueOpen]);

  const showDecoration = labelQueBatchCount > 0;

  const alertCount = labelQueBatchCount <= 99 ? labelQueBatchCount : <FormattedMessage {...messages.ninetyNinePlus} />;
  const alertCountDigits = labelQueBatchCount.toString().length;

  const decorationClassName = classnames({ [style['print-alert-icon']]: showDecoration }, getDigitBasedClassname(alertCountDigits));

  return (
    <div className={baseStyle['menu-item']}>
      <div
        className={baseStyle['icon-wrapper']}
        onClick={handleLabelQueueClick}
        tabIndex={-1}
        title={intl.formatMessage(appHeaderMessages.labelQueueTitle)}
      >
        <PrintQueueIcon alertCount={alertCount} decorationClassName={decorationClassName} showDecoration={showDecoration} />
      </div>
    </div>
  );
};
